'use strict';

// ⚠ .cjs 는 webpack 이 babel 없이 직접 파싱한다 → `??` / `?.` 금지 (production 빌드가 깨진다). 기존 .cjs 헬퍼들과 같은 제약.

// 점수 산출(v2 scoring, v3 summary·export, EV_COUNT 보고서)은 한 문항 안 평가요소의 해당없음 값이 섞이면
// 422 { details: { error_type: 'data_integrity_error', affected_items: [...] } } 로 멈춘다 (backend #1986·#1991).
// 응답자 답과 평가자 판정의 시점이 어긋난 정상 상황이라 자동으로 맞추지 않는다 → 화면은 어느 문항이 막혔는지만 알린다.
// 무결성 422 가 아니면 null.
function integrityIssues(error) {
    const res = error && error.response;
    const details = res && res.status === 422 && res.data && res.data.details;
    if (!details || details.error_type !== 'data_integrity_error') return null;
    return Array.isArray(details.affected_items) ? details.affected_items : [];
}

const MAX_LINES = 20;

// alert 용 한 줄씩. 프로젝트 전체 export 는 업체 수만큼 길어질 수 있어 앞 20건만 보이고 나머지는 건수로.
function integrityIssueLines(items) {
    const lines = items.slice(0, MAX_LINES).map(item =>
        [item.company_name, item.label, item.sub_code && `(${item.sub_code})`].filter(Boolean).join(' '));
    if (items.length > MAX_LINES) lines.push(`외 ${items.length - MAX_LINES}건`);
    return lines;
}

module.exports = { integrityIssues, integrityIssueLines };
